import { useQuery } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { buildEstimatedLeadsUsageQuery, type LeadsUsageEstimation } from '@albacross/frontend-utils'
import type { EPlanName } from '@albacross/types'

import { get } from 'utils/http'

// Not gated on the plan like the customer-facing hook: admins get the estimate for every account.
export const useCustomerLeadsEstimatedUsage = (planName?: EPlanName) => {
  const customerId = useCustomerId()
  const query = buildEstimatedLeadsUsageQuery(planName)

  return useQuery({
    queryKey: ['customer', customerId, 'leads_estimated_usage', query],
    queryFn: () => get<LeadsUsageEstimation>(`/management/customers/${customerId}/leads_estimated_usage`, { query }),
    retry: false,
    refetchOnWindowFocus: false,
  })
}
